/// <reference path="../../../../typings/globals/jquery/index.d.ts" />
/**
 * Rozszerzenie klasy IntersectionObserver
 *
 * @export
 * @class ExtendedIntersectionObserver
 */

export class ExtendedIntersectionObserver {
	constructor(options) {
		let defaultOptions = {
			root: null, // opcja IntersectionObserver
			rootMargin: null, // opcja IntersectionObserver
			threshold: null, // opcja IntersectionObserver
			thresholdSteps: 1,
			shift: null, // {.top .bottom .left .right}
			mode: 'horizontal', // horizontal / vertical / mixed
			sentinels: null,
			customCallback: function(entries, io){
				this.defaultCallback(entries, io);
			}.bind(this),
			testMode: false,
			touchendDelay: 100
		};
		this.options = $.extend({}, defaultOptions, options);
		this.parentObj = (this.options.root !== null)? $(this.options.root) : $('body');

		this.prepareIOInit();
	}

	/**
	 * Przygotowanie Inicjalizacji IntersectionObserver
	 *
	 * @memberof ExtendedIntersectionObserver
	 */
	prepareIOInit(){
		let that = this;

		if ( pageObj.settings.isIntersectionObserver ) {
			if ( that.options.sentinels !== null && that.options.sentinels.length > 0 ) {
				that.initIO();
			} else {
				console.error('No sentinels in IntersectionObserver object');
			}
		}
	}

	/**
	 * Inicjalizacja IntersectionObserver
	 *
	 * @memberof ExtendedIntersectionObserver
	 */
	initIO(){
		let that = this;

		that.IOOptions = this.prepareOptionsForIO();

		that.io = new IntersectionObserver(that.options.customCallback, that.IOOptions);

		that.options.sentinels.forEach(sentinel => {
			if ( $(sentinel).length > 1 ) {
				$(sentinel).each(function(i, e){
					that.addSentinel(document.getElementById(e.id));
					that.addInfoBars(document.getElementById(e.id));
				});
			} else {
				that.addSentinel(document.querySelector(sentinel));
				that.addInfoBars(document.querySelector(sentinel));
			}
		});
	}

	addInfoBars(sentinelElement){
		let that = this;

		if ( that.options.testMode ) {
			if ( that.options.mode == 'horizontal' ) {
				that.createHorizontalInfoBar(sentinelElement, 'scrollDown');
				that.createHorizontalInfoBar(sentinelElement, 'scrollUp');
			} else if (that.options.mode == 'vertical' ) {
				that.createVerticalInfoBar(sentinelElement, 'scrollRight');
				that.createVerticalInfoBar(sentinelElement, 'scrollLeft');
			} else
				console.warn('No handle for mix mode!');
		}
	}

	createHorizontalInfoBar(sentinelElement, scrollDir){
		let that = this;
		let shiftT = Number(that.options.shift.top.replace('px',''));
		let shiftB = Number(that.options.shift.bottom.replace('px',''));
		let sentinel = $(sentinelElement);
		let sentinelHeight = toolsObj.realHeight(sentinel);
		let sentinelTop = sentinel.position().top;
		let sentinelBottom = sentinelTop + sentinelHeight;
		let newTopIn;
		let newTopOut;

		if ( scrollDir == 'scrollDown' ){
			newTopIn = sentinelTop - shiftB;
			newTopOut = sentinelBottom - shiftB;
		} else {
			newTopIn = sentinelBottom + shiftT + 1 // + 1 by sie kreski nie przykrywały
			newTopOut = sentinelTop + shiftT + 1;
		}

		that.parentObj.append('<div class="bar in '+that.options.mode+' '+scrollDir+'" style="top: '+newTopIn+'px"></div>');
		that.parentObj.append('<div class="bar out '+that.options.mode+' '+scrollDir+'" style="top: '+newTopOut+'px"></div>');
	}

	createVerticalInfoBar(sentinelElement, scrollDir){
		let that = this;
		let shiftL = Number(that.options.shift.left.replace('px',''));
		let shiftR = Number(that.options.shift.right.replace('px',''));
		let sentinel = $(sentinelElement);
		let sentinelWidth = toolsObj.realWidth(sentinel);
		let sentinelLeft = sentinel.position().left;
		let sentinelRight = sentinelLeft + sentinelWidth;
		let newLeftIn;
		let newLeftOut;

		if ( scrollDir == 'scrollRight' ){
			newLeftIn = sentinelLeft - shiftR;
			newLeftOut = sentinelRight - shiftR;
		} else {
			newLeftIn = sentinelRight + shiftL + 1 // + 1 by sie kreski nie przykrywały
			newLeftOut = sentinelLeft + shiftL + 1;
		}

		that.parentObj.append('<div class="bar in '+that.options.mode+' '+scrollDir+'" style="left: '+newLeftIn+'px"></div>');
		that.parentObj.append('<div class="bar out '+that.options.mode+' '+scrollDir+'" style="left: '+newLeftOut+'px"></div>');
	}

	/**
	 * Dodawanie sentinelów do obserwacji
	 *
	 * @param {*} sentinelElement
	 * @memberof ExtendedIntersectionObserver
	 */

	addSentinel(sentinelElement){
		let that = this;

		that.printInfo('status','init');
		that.io.observe(sentinelElement);

		$(that.options.root).on('click', function(){
			that.printInfo('status','click');

			that.io.unobserve(sentinelElement);
			that.io.observe(sentinelElement);
		}).on('touchstart', function(){
			that.printInfo('status','touchstart');

			that.io.unobserve(sentinelElement);
			that.io.observe(sentinelElement);
		}).on('touchend', function(){
			that.printInfo('status','touchend');

			setTimeout(function(){ // musi byc opóźnienie z powodu pływania scrolla przy eventach touch
				that.io.unobserve(sentinelElement);
				that.io.observe(sentinelElement);
				that.printInfo('status','touchend: '+that.options.touchendDelay);
			}, that.options.touchendDelay);
		});
	}

	/**
	 * Loguje informacje w trybie testu
	 *
	 * @param {*} kind
	 * @param {*} msg
	 * @memberof ExtendedIntersectionObserver
	 */
	printInfo(kind, msg){
		let that = this;

		if ( that.options.testMode ) {
			let target = $(that.options.root+'_info .'+kind);

			if ( target.length < 1 ) {
				that.createInfoElement(that.parentObj);
				target = $(that.options.root+'_info .'+kind);
			}

			$(target).html(msg);
		}
	}

	/**
	 * Tworzy element do logowania informacji w trybie testu
	 *
	 * @param {*} parent
	 * @memberof ExtendedIntersectionObserver
	 */
	createInfoElement(parent){
		let that = this;

		$('<p id="'+that.options.root.replace('#','')+'_info" class="position-absolute mb-0" style="right: 0; z-index: 100; background-color: blue; color: #fff; padding: .25rem;"><span class="status">-</span> -> <span class="ratio">-</span></p>').insertBefore(parent);
	}

	/**
	 * Przygotowanie parametrów IntersectionObserver
	 *
	 * @returns
	 * @memberof ExtendedIntersectionObserver
	 */
	prepareOptionsForIO() {
		let that = this;
		let IOOptions = {};

		IOOptions.root = ( that.options.root === null )? null : document.querySelector(that.options.root);

		if ( that.options.threshold === null ) {
			IOOptions.threshold = that.createThresholdSteps(that.options.thresholdSteps);
		}

		IOOptions.rootMargin = that.setRootMargin(that.options.rootMargin);

		return IOOptions;
	}

	/**
	 * Utowrzenie array z punktami wywoławczymi (threshold) dla intersectionRatio
	 *
	 * @param {*} steps
	 * @returns
	 * @memberof ExtendedIntersectionObserver
	 */
	createThresholdSteps(steps) {
		steps = ( steps < 1 ) ? 1 : steps;
		let thresholdArray = [0];

		for (let i = 1; i <= steps; i++) {
			thresholdArray[i] = 1 / steps * i;
		}

		return thresholdArray;
	}

	/**
	 * ustawienie rootMargin
	 *
	 * @param {*} rootMargin
	 * @returns
	 * @memberof ExtendedIntersectionObserver
	 */
	setRootMargin(rootMargin) {
		let that = this;

		if ( rootMargin === null ) {
			if ( that.options.shift === null )
				return '0px';

			that.fixShifts(that.options.shift);
		} else
			that.createShiftsFromRootMargin(rootMargin);

		return that.adjustRootMarginToSystem(that.options.shift);
	}

	/**
	 * Uzupełnienie brakujących paraemtrów shift
	 *
	 * @param {*} shift
	 * @returns
	 * @memberof ExtendedIntersectionObserver
	 */
	fixShifts (shift){
		shift.top = ( shift.top === undefined )? '0px' : shift.top;
		shift.bottom = ( shift.bottom === undefined )? '0px' : shift.bottom;
		shift.left = ( shift.left === undefined )? '0px' : shift.left;
		shift.right = ( shift.right === undefined )? '0px' : shift.right;
	}

	/**
	 * Utworzenie shifts na podstawie rootMargin
	 *
	 * @param {*} rootMargin
	 * @memberof ExtendedIntersectionObserver
	 */
	createShiftsFromRootMargin(rootMargin){
		let that = this;

		that.options.shift = {};
		let margins = rootMargin.split(' ');
		let lenght = margins.length;

		that.options.shift.top = margins[0];
		if ( lenght == 1 ) {
			that.options.shift.right = margins[0];
			that.options.shift.bottom = margins[0];
			that.options.shift.left = margins[0];
		} else {
			that.options.shift.right = margins[1];
			that.options.shift.bottom = (lenght == 2)? margins[0] : margins[2];
			that.options.shift.left = (lenght == 4)? margins[3] : margins[1];
		}
	}

	/**
	 * Przekształcenia rootMargin by było zgodne w IOS i anadroid/PC
	 *! ToDo - dostoswać do IOS
	 *
	 * @param {*} rootMargin
	 * @returns
	 * @memberof ExtendedIntersectionObserver
	 */
	adjustRootMarginToSystem(shift){
		let that = this;
//console.log('shifts: ',that.options.root, that.options.shift);

		return shift.top + ' ' + shift.right + ' ' + shift.bottom + ' ' + shift.left;
	}

	defaultCallback(entries, io) {
		let that = this;
		console.log('customCallback', entries, io);

		entries.forEach(entry => {
			if ( that.options.testMode ) {
				if (entry.intersectionRatio <= 0) {
					$(that.options.root).css('border', '5px solid red');
				} else if (entry.intersectionRatio >= 1) {
					$(that.options.root).css('border', '5px solid green');
				} else {
					$(that.options.root).css('border', '5px solid orange');
				}

				that.printInfo('ratio', toolsObj.roundTo(entry.intersectionRatio, 4));
			}
		});
	}
}